import { render, staticRenderFns } from "./OnlinePBXIntegrationComponent.vue?vue&type=template&id=30ed5fdc&"
import script from "./OnlinePBXIntegrationComponent.vue?vue&type=script&lang=ts&"
export * from "./OnlinePBXIntegrationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports